export function linkToDevPatient({ id }: { id?: string } = {}): string {
  return ["/dev-patient", id].filter(Boolean).join("/");
}

function linkToDevPatientOverview({ id }: { id?: string } = {}): string {
  return `${linkToDevPatient({ id })}/overview`;
}

export function linkToDevPatientHistory({ id }: { id: string }): string {
  return `${linkToDevPatientOverview({ id })}/history`;
}

export function linkToDevPatientInvoices({ id }: { id: string }): string {
  return `${linkToDevPatientOverview({ id })}/invoices`;
}

export function linkToDevPatientInsurance({ id }: { id: string }): string {
  return `${linkToDevPatientOverview({ id })}/insurance`;
}

export function linkToDevPatientDispensePrescriptions({
  id,
}: {
  id: string;
}): string {
  return `${linkToDevPatient({ id })}/dispense-prescriptions`;
}

export function linkToDevPatientAddInvestigations({
  id,
}: {
  id: string;
}): string {
  return `${linkToDevPatient({ id })}/add-investigations`;
}

export function linkToDevPatientAddConsultation({
  id,
}: {
  id: string;
}): string {
  return `${linkToDevPatient({ id })}/add-consultation`;
}
